import { Row, ScrollArea, SideSheet } from 'components/Blocks';

import { SidebarContent } from './Content';
import { useAppWrapper } from '../WrapperContext';

import { cn } from 'styles';
import { useUser } from 'hooks';

export function Sidebar() {
  const loggedUser = useUser();

  const { showMobileSidebar, isSideBarOpen, toggleSideBar } = useAppWrapper();

  if (showMobileSidebar) {
    return (
      <SideSheet
        className="scrollbar max-w-[300px] overflow-y-auto border-r-0 bg-primary text-primary-foreground dark:bg-card dark:text-card-foreground"
        isOpen={isSideBarOpen}
        close={toggleSideBar}
        side="left"
        title={
          <Row>
            <span className="mr-auto font-bold text-primary-foreground dark:text-muted-foreground">
              {loggedUser.team.name}
            </span>
          </Row>
        }
      >
        <SidebarContent />
      </SideSheet>
    );
  }

  return (
    <ScrollArea
      orientation="vertical"
      className={cn(
        isSideBarOpen ? 'w-[272px]' : 'w-[44px]',
        'flex-shrink-0 bg-primary text-primary-foreground transition-width duration-300 dark:bg-card dark:text-card-foreground',
      )}
    >
      <SidebarContent />
    </ScrollArea>
  );
}
